import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse, isAxiosError } from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { httpGET } from '../../services/http.ts';
import { AuditLog, LoadAuditLogsRequest } from '../../types/auditLog.ts';
import { PageResponse } from '../../types/subscription.ts';
import { auditLogReducer } from '../reducers/auditLog.reducer.ts';
import { toastReducer } from '../reducers/toast.reducer.ts';

const { loadAuditLogs, setAuditLogs, setAuditLogsError } = auditLogReducer.actions;
const { showToast } = toastReducer.actions;

function buildQueryString(params: LoadAuditLogsRequest): string {
  const search = new URLSearchParams();
  search.append('page', String(params.page));
  search.append('pageSize', String(params.pageSize));
  if (params.userId !== undefined) search.append('userId', String(params.userId));
  if (params.action) search.append('action', params.action);
  if (params.entityType) search.append('entityType', params.entityType);
  if (params.entityId) search.append('entityId', params.entityId);
  if (params.status) search.append('status', params.status);
  if (params.from) search.append('from', params.from);
  if (params.to) search.append('to', params.to);
  return search.toString();
}

function* loadAuditLogsAction(action: PayloadAction<LoadAuditLogsRequest>) {
  try {
    const query = buildQueryString(action.payload);
    const { data }: AxiosResponse<PageResponse<AuditLog>> = yield call(httpGET, `/audit-logs?${query}`);
    yield put(
      setAuditLogs({
        content: data.content,
        page: data.page,
        pageSize: data.pageSize,
        totalElements: data.totalElements,
      }),
    );
  } catch (error) {
    let errorMessage = 'auditLogs.toast.loadError';
    if (isAxiosError(error) && error.response?.data) {
      errorMessage = error.response.data as string;
    }
    yield put(setAuditLogsError(errorMessage));
    yield put(
      showToast({
        message: errorMessage,
        type: 'error',
      }),
    );
  }
}

export default function* auditLogSaga() {
  yield all([takeLatest(loadAuditLogs.type, loadAuditLogsAction)]);
}
